import React, { useState, useEffect } from 'react';
import { Flex, Result, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { routesPath } from '../../common/constants/routesPath';
import { fontSize, fontWeight, fontFamily, primitiveColors, colors, spacing } from '../../theming';
import Confetti from 'react-confetti';

const { Text, Title } = Typography;

const Congratulations = () => {
    const { t } = useTranslation(['congratulations']);
    const [searchParams] = useSearchParams();
    const [confetti, setConfetti] = useState(false);
    const credit = searchParams.get('credit');
    const vinCode = searchParams.get('vinCode');
    const navigate = useNavigate();

    useEffect(() => {
        const timeout = setTimeout(() => {
            setConfetti(true);
        });

        return () => clearTimeout(timeout);
    }, []);

    return (
        <Flex justify="center" align="center" style={{ height: '80vh', width: '100%', backgroundColor: '#f5f5f5' }}>
            {confetti && <Confetti />}
            <Result
                status="success"
                title={
                    <Title
                        style={{
                            fontSize: fontSize.xl,
                            fontWeight: fontWeight.xl,
                            fontFamily: fontFamily.first,
                            color: primitiveColors.primary,
                        }}
                    >
                        {t('congratulations.title')}
                    </Title>
                }
                subTitle={
                    <Flex>
                        <Text
                            style={{
                                fontSize: fontSize.md,
                                fontWeight: fontWeight.md,
                                fontFamily: fontFamily.first,
                            }}
                        >
                            {t('congratulations.description', { credit })}
                        </Text>
                    </Flex>
                }
                extra={
                    <Button
                        type="primary"
                        onClick={() => navigate(`${routesPath.ROOT.DASHBOARD}${vinCode ? `?vinCode=${vinCode}` : ''}`)}
                        key="dashboard"
                        size="large"
                        style={{
                            fontSize: fontSize.md,
                            fontWeight: fontWeight.md,
                            fontFamily: fontFamily.first,
                            backgroundColor: primitiveColors.main,
                            color: colors.white,
                            borderRadius: 99,
                            padding: `${spacing.sm} ${spacing.md}`,
                        }}
                    >
                        {t('congratulations.button')}
                    </Button>
                }
            />
        </Flex>
    );
};

export default Congratulations;
